<div class="question-type__text">
  <h1 class="fs__xxl">Information Page</h1>
  <p class="fs__md">
    A non-question page used to present information to participants before they continue with the survey. Useful for providing instructions or context.
  </p>
  <h2 class="fs__lg">Best Practices</h2>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Break up sections</span>
      <span class="sub-text">Use an information page to introduce new sections of the survey</span>
    </li>
  </ul>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">Now we are going to ask you some questions about yourself.</p>
</div>
